import type { JSX } from 'react';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { SortSelect } from './SortSelect';
import { type ItemStyle, type SortDirection, SortKey, type StarterSorting } from './types';

export type StarterSortRowProps = {
  style: ItemStyle;
  starterSorting: StarterSorting | null;
  onSort: (sortKey: SortKey, direction: SortDirection | null) => void;
  onReset: () => void;
};

export function StarterSortRow({
  style,
  starterSorting,
  onSort,
  onReset,
}: StarterSortRowProps): JSX.Element {
  return (
    <div className="starter-list-filter" style={style}>
      <div key="sort-start-number">
        <SortSelect
          sortKey={SortKey.START_NUMBER}
          sortDirection={starterSorting?.[0] === SortKey.START_NUMBER ? starterSorting[1] : null}
          onSort={(direction) => onSort(SortKey.START_NUMBER, direction)}
        />
      </div>
      <div key="sort-name">
        <SortSelect
          sortKey={SortKey.NAME}
          sortDirection={starterSorting?.[0] === SortKey.NAME ? starterSorting[1] : null}
          onSort={(direction) => onSort(SortKey.NAME, direction)}
        />
      </div>
      <div key="sort-offset">
        <SortSelect
          sortKey={SortKey.OFFSET}
          sortDirection={starterSorting?.[0] === SortKey.OFFSET ? starterSorting[1] : null}
          onSort={(direction) => onSort(SortKey.OFFSET, direction)}
        />
      </div>
      <div key="deselect-tag-button">
        <div className="starter-list-button" {...onClickGenerator(onReset)}>
          {t('list.RESET')}
        </div>
      </div>
    </div>
  );
}
